import { render, staticRenderFns } from "./register-pdf.vue?vue&type=template&id=4cb3a126&scoped=true&"
import script from "./register-pdf.vue?vue&type=script&lang=js&"
export * from "./register-pdf.vue?vue&type=script&lang=js&"
import style0 from "./register-pdf.vue?vue&type=style&index=0&id=4cb3a126&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cb3a126",
  null
  
)

export default component.exports